/* RESPONSIBLE TEAM: team-ai-agent */
import Route from '@ember/routing/route';
import type Transition from '@ember/routing/transition';
import { inject as service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';

// Legacy /ask route — redirects to the combined agent route.
// Kept for backward compatibility with bookmarks and external links.
export default class AskIndexRoute extends Route {
  @service declare router: RouterService;

  beforeModel(transition: Transition) {
    this.router.replaceWith('apps.app.automation.fin-ai-agent.ask', {
      queryParams: transition.to?.queryParams ?? {},
    });
  }
}
